import { Box, EnhancedDimension, Skeleton } from '@factorialco/deprecated-design-system'

export const SkeletonValue = ({
  width = 's120',
  height = 's16',
  left,
}: {
  width?: EnhancedDimension
  height?: EnhancedDimension
  left?: string
}) => {
  return (
    <Box style={{ ...(left && { paddingLeft: left }) }}>
      <Skeleton width={width} height={height} />
    </Box>
  )
}
